import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import ProductSlideshow from '../components/ProductSlideshow';

const Home = () => {
  const navigate = useNavigate();
  return (
    <div className="section">
      <section className="hero">
        <div>
          <h1>RokaTC — Fabrication de couverture et de sac</h1>
          <p>Entreprise de fabrication de tapis, couettes et sacs. Usine basée à Sousse, main‑d'œuvre tunisienne, capacité volumes et contrôle qualité rigoureux.</p>
          <div style={{ display: 'flex', gap: 12, marginTop: 16 }}>
            <Link to="/produits" className="btn">Voir nos produits</Link>
            <button className="btn" onClick={() => navigate('/contact')}>Obtenir un devis</button>
          </div>
          <div style={{ marginTop: 12, display: 'flex', gap: 8, flexWrap: 'wrap' }}>
            <span className="badge">MOQ flexible</span>
            <span className="badge">OEM / Private Label</span>
            <span className="badge">Export global</span>
          </div>
        </div>
        <div>
          <ProductSlideshow folderName='carpet'></ProductSlideshow>
        </div>
      </section>

      {/* Actually we don't need this section for now */}

      {/* <section className="section">
        <h2>Catégories phares</h2>
        <div className="grid products-grid">
          <Link className="card" to="/produits?categorie=Tapis">
            <img src="/assets/tapis.svg" alt="Tapis" style={{ width: '100%', height: 160, objectFit: 'cover', borderRadius: 12 }} />
            <strong>Tapis</strong>
            <span style={{ color: '#64748b' }}>Tissés, tuftés, personnalisés</span>
          </Link>
          <Link className="card" to="/produits?categorie=Couettes">
            <img src="/assets/couette.svg" alt="Couettes" style={{ width: '100%', height: 160, objectFit: 'cover', borderRadius: 12 }} />
            <strong>Couettes</strong>
            <span style={{ color: '#64748b' }}>Hiver / été, garnissages variés</span>
          </Link>
          <Link className="card" to="/produits?categorie=Sacs">
            <img src="/assets/sac.svg" alt="Sacs" style={{ width: '100%', height: 160, objectFit: 'cover', borderRadius: 12 }} />
            <strong>Sacs</strong>
            <span style={{ color: '#64748b' }}>Shopping, sport, logistique</span>
          </Link>
        </div>
      </section> */}

      <section className="section">
        <h2>Pourquoi RokaTC ?</h2>
        <div className="grid" style={{ gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))' }}>
          <div className="card">
            <strong>Qualité & volumes</strong>
            <p>Contrôle qualité local, délais maîtrisés, volumes importants pour B2B/wholesale.</p>
          </div>
          <div className="card">
            <strong>Personnalisation</strong>
            <p>Produits OEM, étiquetage privé et spécifications selon vos besoins.</p>
          </div>
        </div>
      </section>
    </div>
  )
};

export default Home;
